<script setup>
import { DxButton } from 'devextreme-vue/button'

import { useDialog } from '@/composables/dialog'
const { customDialog } = useDialog()

const props = defineProps({
  icon: { type: String },
  text: { type: String },
  hint: { type: String, default: null },
  confirmTitle: { type: String },
  confirmMessage: { type: String },
  yesText: { type: String },
  noText: { type: String },
  disabled: { type: Boolean, default: false },
  onConfirm: { type: Function, required: true },
  stylingMode: { type: String, default: 'text' },
  type: { type: String, default: 'normal' },
  showTitle: { type: Boolean, default: true },
})

const onClick = async() => {
  if (props.disabled) return

  const result = await customDialog(props.confirmTitle, props.confirmMessage, props.yesText, props.noText)
  if (result === true) {
    await props.onConfirm()
  }
}
</script>

<template>
  <dx-button
    :icon="icon"
    :text="text"
    :hint="hint"
    :disabled="disabled"
    :styling-mode="stylingMode"
    :type="type"
    @click="onClick"
  />
</template>
